package com.karawek.core.ui.components

import androidx.compose.material3.Switch
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.ui.Modifier
import com.karawek.core.ui.haptics.HapticType
import com.karawek.core.ui.haptics.LocalHapticsEnabled
import com.karawek.core.ui.haptics.performHapticIfEnabled

@Composable
fun CoreToggle(
    checked: Boolean,
    enabled: Boolean = true,
    onCheckedChange: (Boolean) -> Unit,
    modifier: Modifier = Modifier,
) {
    val hapticsEnabled by rememberUpdatedState(LocalHapticsEnabled.current)

    Switch(
        checked = checked,
        enabled = enabled,
        onCheckedChange = {
            performHapticIfEnabled(hapticsEnabled, HapticType.Selection)
            onCheckedChange(it)
        },
        modifier = modifier,
    )
}